// extracted by mini-css-extract-plugin
export default {"h2":"wrLqeq1gHtKvYVh3O7PK","item":"Ne87_dbzfXwFm1JeY4vW"};